import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { memo } from "react";
import { ChannelContext } from "../App";

const ChannelCard = ({ channel, minimal = false, setOpen }) => {
  const { setPlayChannel } = useContext(ChannelContext);
  const navigate = useNavigate();

  const handleClick = () => {
    sessionStorage.setItem("channel", JSON.stringify(channel));
    setPlayChannel(channel);
    navigate(`/${channel.type}/${channel.chId}`);
    if (minimal) {
      sessionStorage.removeItem("channels");
      setOpen(false);
    }
  };

  return (
    <>
      {minimal ? (
        <button
          key={channel?.chId}
          className="channel-minimal-button"
          onClick={handleClick}
        >
          <div className="channel-img-minimal">
            <img
              src={
                channel?.extImg
                  ? channel.image
                  : `${process.env.PUBLIC_URL}/images/${channel?.image}`
              }
              alt={channel?.id}
              width="100%"
              loading="lazy"
              decoding="async"
            />
          </div>
          <div className="channel-name-minmal">
            <span>{channel?.name}</span>
          </div>
        </button>
      ) : (
        <div className="channel-card-wrapper">
          <button className="channel-card" onClick={handleClick}>
            <div className="channel-image">
              <img
                src={
                  channel?.extImg
                    ? channel.image
                    : `${process.env.PUBLIC_URL}/images/${channel.image}`
                }
                alt={channel.image}
                width="100%"
                style={{ transform: `scale(${channel.scale})` }}
                loading="lazy"
                decoding="async"
              />
            </div>
          </button>
          <span className="channel-name">{channel.name}</span>
        </div>
      )}
    </>
  );
};

export default memo(ChannelCard);
